export enum CurrencyEnum {
    EUR = 0,
    RON = 1,
    GBP = 2,
    USD = 3
}
